import { differenceInDays, differenceInMinutes } from 'date-fns'
import utcValues from './utc-values'

export default function isRecent({
  time,
  timeDiference,
  timeUnit,
}) {
  if (!time) return false
  const createdTime = utcValues(time)
  let diference = 0
  if (timeUnit === 'dd') {
    diference = differenceInDays(new Date(), createdTime)
  }
  if (timeUnit === 'mm') {
    diference = differenceInMinutes(new Date(), createdTime)
  }
  if (diference < timeDiference) return true
  return false
}
